export class EDUVideo {
    _id: string;
    category: string;
    name: string;
    description: string;
    filename: string;
    mp4_path: string;
    placeholder_path: string;
    deleted: boolean;

    createdAt: Date;
    updatedAt: Date;
}